<template>
  <div class="nx-searcher-filter-sections pr-4">
    <nx-site-selector :label="$t('message.searcher.filters.values.' + filter)"
                      :value="value"
                      :rules="validateValue"
                      :disabled="disabled"
                      :multiple="true"
                      @input="updateFilter"></nx-site-selector>
  </div>
</template>

<script>
import MultiValueFilter from '../mixins/MultiValueFilter';
import Filter from './Filter';

export default {
  name: 'nx-searcher-filter-taxonomy',
  extends: Filter,
  mixins: [MultiValueFilter],
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    validateValue() {
      return [
        (values) => {
          if (this.required && values.length === 0) {
            return this.$t('message.searcher.filters.values.siteIdEmpty');
          }
          return true;
        },
      ];
    },
  },
  mounted() {
    if (!this.value || this.value.length === 0) {
      this.updateFilter([this.$store.getters.context.siteId]);
    }
  },
};
</script>
